export default __webpack_public_path__ + "static/media/share-twitter-icon.e106faf1.svg";